/**
 * Clipboard writes from a Braze banner iframe are blocked by the `clipboard-write` Permissions
 * Policy (we don't control the `allow` attribute the SDK puts on the frame), so copying always runs
 * here in the parent document.
 */
export const writeToClipboard = async (text: string): Promise<boolean> => {
  if (import.meta.server || !text) return false

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch {
    // Denied, or no transient user activation — fall through to the legacy path.
  }

  // Safari < 13.1 and any context where the async API is unavailable.
  const field = document.createElement('textarea')
  try {
    field.value = text
    field.setAttribute('readonly', '')
    field.style.position = 'fixed'
    field.style.opacity = '0'
    document.body.appendChild(field)
    field.select()
    return document.execCommand?.('copy') ?? false
  } catch {
    return false
  } finally {
    field.remove()
  }
}
